function normalizeTone(tone) {
    if (tone === 'danger') {
        return 'error';
    }

    if (tone === 'success' || tone === 'info' || tone === 'warning' || tone === 'error') {
        return tone;
    }

    return 'info';
}

export function createInlineFeedbackController({ documentRef, feedback }) {
    const show = (tone, render) => {
        feedback.hidden = false;
        feedback.dataset.tone = normalizeTone(tone);
        feedback.replaceChildren();
        render();
    };

    return {
        clear() {
            feedback.hidden = true;
            delete feedback.dataset.tone;
            feedback.replaceChildren();
        },
        showContent(tone, render) {
            if (typeof render !== 'function') {
                return;
            }

            show(tone, () => {
                render({
                    createElement: (tagName) => documentRef.createElement(tagName),
                });
            });
        },
        showMessage(message, tone = 'info') {
            show(tone, () => {
                feedback.textContent = String(message);
            });
        },
    };
}
